import { isSafariBrowser } from './platform';

export const browserTarget = isSafariBrowser ? '' : '_blank';

export const formatMoney = (value = 0, currency = 'CAD', precision = 0) => new Intl.NumberFormat('en-CA',
  {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(value);

/**
 * Returns the phone number passed in formated as "(xxx) xxx-xxxx".
 *
 * @param {String} phone number to format
 * @returns {String} The phone number in the format "(xxx) xxx-xxxx",
 * or '' if not a 10 digit phone number
 * @public
 */

export function formatPhoneNumber(phone) {
  if (!phone || phone.length !== 10) return '';

  const areaCode = phone.substr(0, 3);
  const firstChunk = phone.substr(3, 3);
  const secondChunk = phone.substr(6, 4);

  return `(${areaCode}) ${firstChunk}-${secondChunk}`;
}
